module.exports = __webpack_public_path__ + "static/media/_Mastercard.09d76c16.svg";